import { addCurrentPlaylistSongsToPlayerPlaylist, addCurrentArtistSongsToPlayerPlaylist, addFavoriteSongsToPlayerPlaylistStartAt, getRandomOrderSongs, setRadioStationDetail, finishPlaying } from '../../actions/musica/player-action-creators';
import { HIDE_MODAL, MODAL_MUSIC_CONTEXTUAL_MENU, SHOW_MODAL } from "../modal";
import { showNotification } from '../../actions/notification';

import * as EVENTS from '../../actions/musica/playermusica';
import * as USER_TYPES from '../../constants/musica/users-type';
import * as userType from '../../constants/musica/users-type';
import * as playerConstants from '../../constants/musica/player';
import * as playerType from '../../utils/playerConstants';

import pgm_musica from '../../constants/musica/pgm_musica.json';
import MusicUtils from '../../actions/musica/music-actions';
import Asset from "../../requests/apa/Asset";
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Translator from './../../requests/apa/Translator';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

const SKIPS_ALLOWED = 6;
const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;

export const canSkip = (state, dispatch) => {
  if (state.user.musicUser.type === userType.PREMIUM) {
    return true;
  }

  const skips = JSON.parse(DeviceStorage.getItem("USER_SKIPS"));

  if(!skips){
    return true;
  }

  const skipsPerHour = skips.slice(-SKIPS_ALLOWED).filter((skip) => ((Date.now() - skip.date) < HOUR));
  const skipsOutTime = skips.filter((skip) => ((Date.now() - skip.date) > HOUR));

  if(skipsOutTime.length > 0){
    dispatch({ type: EVENTS.UPDATE_SKIPS, skips: skipsPerHour });
  }

  return skipsPerHour.length < SKIPS_ALLOWED;
};

export const getSongAtIndex = (state, index) => {
  return { ...state.playlist.originalContent[index] };
};

export const getRandomIndex = (length) => {
  const min = 0;
  const max = length;
  if (max === 1) {
    return 0;
  }
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const setFirstPlaylistFree = (playlistId) => (dispatch) => {
  dispatch({ type: EVENTS.SET_FREEPLAYLIST_ID, playlistId });
}

export const doPGMSongs = (index = 0, statelocal) => (dispatch, getState) => {
  const {user : {musicUser : {type = userType.ANONYMOUS} = {} } = {}} = getState();
  const tracks = statelocal.tracks;
  if(type === userType.FREE) {

    tracks.forEach((track) => {
      track.url = track.url + '&playlistId=46180748';
    });
  }

  pgm_musica.media.content_id = tracks[index].id;
  pgm_musica.media.video_url = tracks[index].url;
  pgm_musica.media.duration = tracks[index].durationInSeconds;

  dispatch(addFavoriteSongsToPlayerPlaylistStartAt(index, tracks));

  const details = {
    type:       'song',
    songName:    tracks[index].name,
    songNumber:  tracks[index].trackNumber,
    albumName:   tracks[index].albumName,
    artistName:  tracks[index].artist,
  };

  pgm_musica.details = details;
  if (tracks[index] && tracks[index].tracking && typeof tracks[index].tracking === 'object') {
    pgm_musica.tracking = tracks[index].tracking;
  }

  return pgm_musica;
};

export const doPGMAlbum = (index = 0, statelocal) => (dispatch, getState) => {
  const state = getState();
  const {user : {musicUser : {type = userType.ANONYMOUS} = {} } = {}} = getState();
  const volumes = statelocal.volumes;
  let playlistDetail  = [];
  let trackIndex=0;
  if (volumes){
    volumes.map(volume => {
        volume.tracks.map(track => {
          trackIndex++;
          playlistDetail.push({...track, trackNumber: trackIndex});
        }
      );
    });
  } else if (statelocal.albumTracks){    //when statelocal is just a list of albumtracks
     const tracks = statelocal.albumTracks;
     tracks.map(track => {
          trackIndex++;
          playlistDetail.push({...track, trackNumber: trackIndex});
        });
  }

  const playerTracks = statelocal && statelocal.playerTracks ? statelocal.playerTracks : [];
  playlistDetail = Utils.mapTracksTodoPGMAlbum(playlistDetail, playerTracks);

  if(type === userType.FREE) {
    const freeplaylist = state.playermusica.forceFreePlaylistId;
    playlistDetail.forEach((track) => {
      track.url = track.url + '&playlistId=46180748';
    });
  }

  dispatch(addCurrentArtistSongsToPlayerPlaylist(true, true, false, index, playlistDetail));

  pgm_musica.media.content_id = playlistDetail[index].id;
  pgm_musica.media.video_url = playlistDetail[index].url;
  pgm_musica.media.duration = playlistDetail[index].durationInSeconds;
  pgm_musica.media.streamType = playerType.AUDIO;

  const details = {
    type:       'album',
    songName:   playlistDetail[index].name,
    songNumber: playlistDetail[index].trackNumber,
    albumName:  playlistDetail[index].albumName,
    artistName: playlistDetail[index].artist
  };

  pgm_musica.details = details;

  if (
    playlistDetail[index] &&
    playlistDetail[index].tracking &&
    typeof playlistDetail[index].tracking === 'object'
  ) {
    pgm_musica.tracking = playlistDetail[index].tracking;
  }

  return pgm_musica;
};

export const doPGMPlaylist = (index = 0, statelocal) => (dispatch, getState) => {
  const state = getState();
  const {user : {musicUser : {type = userType.ANONYMOUS} = {} } = {}} = getState();
  const playlistDetail = statelocal.playlistDetail;
  let songs = playlistDetail.tracks;
  const isFreePlaylist = songs[0].songSourceType === playerConstants.ACCESS_TYPES.FREE_PLAYLIST;
  const isUserPremium = type === userType.PREMIUM;

  if(isFreePlaylist && !isUserPremium & !canSkip(state, dispatch)){
    dispatch(showNotification({show:true, title:`${Translator.get('error_music_skip_message', 'Claro música gratis permite solamente 6 skips por hora')}`, msg: null , faClass: null, type:'message'}));
    return;
  }

  if (isFreePlaylist && !isUserPremium) {
    const date = Date.now();
    dispatch({type: EVENTS.NOTIFY_SKIP, skip: {date}});
  }

  if (isFreePlaylist && !isUserPremium) {
    index = 0;
    songs = getRandomOrderSongs(songs);
    playlistDetail.tracks = songs;
  }

  const playerTracks =
    statelocal && statelocal.playlistDetail && statelocal.playlistDetail.playerTracks
      ? statelocal.playlistDetail.playerTracks
      : [];
  songs = Utils.mapTracksTodoPGMAlbum(songs, playerTracks);

  if(!isFreePlaylist && type === userType.FREE) {
    songs.forEach((track) => {
      track.url = track.url + '&playlistId=46180748';
    });
    playlistDetail.tracks = songs;
  }

  dispatch(addCurrentPlaylistSongsToPlayerPlaylist(true, true, true, index, playlistDetail));

  pgm_musica.media.content_id = songs[index].id;
  pgm_musica.media.video_url = songs[index].url;
  pgm_musica.media.duration = songs[index].durationInSeconds;
  pgm_musica.media.streamType = playerType.AUDIO;

  const details = {
    type:         'playlist',
    playlistName: songs[index].playlistName,
    songName:     songs[index].name,
    songNumber:   songs[index].trackNumber,
    albumName:    songs[index].albumName,
    artistName:   songs[index].artist,
  };

  pgm_musica.details = details;

  if (songs[index] && songs[index].tracking && typeof songs[index].tracking === 'object') {
    pgm_musica.tracking = songs[index].tracking;
  }

  return pgm_musica;
};

export const doPGMRadio = (url, item) => (dispatch, getState) => {
  pgm_musica.media.content_id = item.id;
  pgm_musica.media.video_url = url;
  pgm_musica.media.duration = 0;
  pgm_musica.media.streamType = playerType.RADIO;

  dispatch(setRadioStationDetail(item));

  const details = {
    type:         'radio',
    radioName:    item.name,
    radioStation: item.dial + item.band
  };

  pgm_musica.details = details;
  return pgm_musica;
};

export const configSetupPlay = () => (dispatch, getState) => {
  const state = getState();
  const user = state.user.musicUser;
  const player = state.playermusica;
  if(!player.firstPlay){
    if (user.type === USER_TYPES.PREMIUM || user.type === USER_TYPES.FREE) {
      MusicUtils.setupPlay(user).then((setupPlayResponse) => {
        if (setupPlayResponse.success === true) {
          dispatch(setFirstPlay());
          return true;
        } else {
          return false;
        }
      }).catch(err => {
        return false;
      });
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const checkSinglePlay = () => (dispatch, getState) => {
  const state = getState();
  const user = state.user.musicUser;
  if (user.type === USER_TYPES.PREMIUM || user.type === USER_TYPES.FREE) {
    MusicUtils.checkSinglePlay(user)
      .then((singlePlayResponse) => {
        if (singlePlayResponse.success !== true) {
          const { error: { code = "" } = {} } = singlePlayResponse;
          // playing simultaneo
          if (code === "CMS_049") {
            dispatch({
              type: SHOW_MODAL,
              modalType: MODAL_MUSIC_CONTEXTUAL_MENU,
              modalProps: {
                title: "Estás reproduciendo música en otro dispositivo.",
                menuItems: [
                  {
                    title: "Continuar con la reproducción aquí.",
                    action: () => dispatch(finishPlaying()),
                  },
                  {
                    title: "Continuar en otro dispositivo.",
                    action: () =>
                      dispatch({
                        type: HIDE_MODAL,
                        modalType: MODAL_MUSIC_CONTEXTUAL_MENU,
                      }),
                  },
                ],
              },
            });

            return false;
          } else {
            return true;
          }
        }
        return true;
      })
      .catch((err) => {
        logger.error(err);
        return true;
      });
  }
};

export const showModalSinglePlay = () => (dispatch, getState) => {
  dispatch({
    type: SHOW_MODAL,
    modalType: MODAL_MUSIC_CONTEXTUAL_MENU,
    modalProps: {
      title: "Estás reproduciendo música en otro dispositivo.",
      menuItems: [
        {
          title: 'Continuar con la reproducción aquí.',
          action: () => dispatch(finishPlaying())
        },
        {
          title: 'Continuar en otro dispositivo.',
          action: () => dispatch({
            type: HIDE_MODAL,
            modalType: MODAL_MUSIC_CONTEXTUAL_MENU
          })
        },
      ],
    }
  });
};

export const sendMetricsMusicaStarted = (currentTime) => (dispatch, getState) => {
  const state = getState().playermusica.oldCurrentContent;
  if(state.id !== null && state.id !== '' && state.id !== ""){
    dispatch(sendMetricsMusica(currentTime, false, true));
  }
}

export const sendMetricsMusica = (currentTime, isStarted, flag = false) => (dispatch, getState) => {
  const state = getState();
  const {user : {musicUser : {type = userType.ANONYMOUS} = {} } = {}} = getState();
  const timestamp = (new Date()).getTime();
  const duration =  Math.ceil(currentTime);
  let currentContent;
  let contentType;
  let metricType;

  if(!flag){
    currentContent = state.playermusica.currentContent;
    contentType = state.playermusica.contentType;
  } else {
    currentContent = state.playermusica.oldCurrentContent;
    contentType = state.playermusica.oldCurrentContentcontentType;
  }

  let songSourceType = currentContent.songSourceType;

  if(duration <= 30){
    return;
  }

  if (type !== userType.PREMIUM && currentContent.songSourceType !== playerConstants.ACCESS_TYPES.FREE_PLAYLIST) {
    if(currentContent.listSourceType !== playerConstants.ACCESS_TYPES.PROMO_PLAYLIST) {
      return Promise.resolve();
    }
  }

  if (contentType === playerConstants.CONTENT_TYPES.SPOT || duration <= 0) {
    return Promise.resolve();
  }

  if (currentContent.listSourceType === playerConstants.ACCESS_TYPES.PROMO_PLAYLIST) {
    songSourceType = playerConstants.ACCESS_TYPES.PROMO_PLAYLIST;
  }

  switch (songSourceType) {
    case playerConstants.ACCESS_TYPES.RADIO_ARTIST:
      metricType = playerConstants.METRICS_TYPES.RADIO_ARTIST;
      break;
    case playerConstants.ACCESS_TYPES.RADIO_GENRE:
      metricType = playerConstants.METRICS_TYPES.RADIO_GENRES;
      break;
    case playerConstants.ACCESS_TYPES.NO_FREE_PLAYLIST:
      metricType = playerConstants.METRICS_TYPES.PLAYLIST_SYSTEM;
      break;
    case playerConstants.ACCESS_TYPES.USER_PLAYLIST:
      metricType = playerConstants.METRICS_TYPES.PLAYLIST_USER;
      break;
    case playerConstants.ACCESS_TYPES.FREE_PLAYLIST:
      metricType = playerConstants.METRICS_TYPES.PLAYLIST_FREE;
      break;
    case playerConstants.ACCESS_TYPES.PROMO_PLAYLIST:
      metricType = playerConstants.METRICS_TYPES.PLAYLIST_PROMO;
      break;
    default:
      metricType =  playerConstants.METRICS_TYPES.UNKNOWN;
      break;
  }

  const data = {
    id: currentContent.id,
    metricType,
    isStarted,
    duration,
    timestamp,
    playlistId: currentContent.playlistId,
  };

  MusicUtils.sendMetrics(data, state.user.musicUser);
};

export const isPreviewSong = () => (dispatch, getState) => {
  const userReduxState = getState().user.musicUser.type === userType.PREMIUM;
  const songSource = getState().playermusica.currentContent.songSourceType !== playerConstants.ACCESS_TYPES.FREE_PLAYLIST;
  if(userReduxState){ return false; }
  if(songSource){ return true; }
  return false;
}

export const canGoToNextSong = () => (dispatch, getState) => {
  const state = getState();
  const isUserPremium = state.user.musicUser.type === userType.PREMIUM;
  const isFreePlaylist = state.playermusica.currentContent.songSourceType === playerConstants.ACCESS_TYPES.FREE_PLAYLIST;

  if (isFreePlaylist) {
    if (!canSkip(state, dispatch)) {
      dispatch(showNotification({
        show: true,
        title: `${Translator.get('error_music_skip_message', 'Claro música gratis permite solamente 6 skips por hora')}`,
        msg: null,
        faClass: null,
        type: 'message'
      }));
      return false;
    }

    if (!isUserPremium) {
      const date = Date.now();
      dispatch({type: EVENTS.NOTIFY_SKIP, skip: {date}});
    }
  }

  return true;
}

export const checkListType = () => (dispatch, getState) => {
  return getState().user.musicUser.type === userType.FREE;
}

export const checkSongType = () => (dispatch, getState) => {
  return getState().playermusica.contentType;
}

export const repeatModeMusicStatus = () => (dispatch, getState) => {
  return getState().playermusica.repeatMode === playerConstants.PLAYER_REPEAT_MODES.REPEAT_SINGLE;
}

export const checkFavoriteContent = () => (dispatch, getState) => {
  const state = getState().playermusica;
  const configContent = {
    isFavorite : state.currentContent.isFavorite,
    isRepeat   : state.repeatMode,
    isShuffle  : state.isShuffle
  }
  return configContent;
}

export const checkFavoriteInsidePlayer = () => (dispatch, getState) => {
  const state = getState().playermusica;
  if(state.currentContent.isFavorite){
    try {
      const btnFav = document.getElementById("favoriteBtn");
      btnFav.getElementsByTagName('img')[0].setAttribute("src", Asset.get('player_controls_favorited_selected'));
    } catch(e){ /***/}
  }
}

export const startSpot = () => (dispatch) => {
  const isPlaying = true;
  dispatch({ type: EVENTS.SET_PLAYING_SPOT, isPlaying });
};

export const setFirstPlay = (time) => (dispatch) => {
  dispatch({
    type: EVENTS.SET_FIRST_PLAY,
    payload: time,
  });
};

export const doUpdateFlagStatus = (status) => (dispatch) => {
  dispatch({ type: EVENTS.UPDATE_FLAG_STATUS, status });
};




// WEBPACK FOOTER //
// ./src/actions/musica/player-shared-action-creators.js